module.exports = __webpack_public_path__ + "static/img/CgoRDGJGqpqAbyNxAAMdw3hS5fs148.a69b589.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CgoRDGJGqpqAbyNxAAMdw3hS5fs148.jpg
// module id = FhGP
// module chunks = 73